import { render } from "./ImageDrawCanvas.vue?vue&type=template&id=5c32eeb1"
import script from "./ImageDrawCanvas.vue?vue&type=script&lang=js"
export * from "./ImageDrawCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__